import {
    Col,
    Row,
    Modal,
    Form,
    Input,
    Select,
    Switch,
    TimePicker,
    Dropdown,
    Table,
    Spin,
    Collapse,
    notification,
    Button,
    Popconfirm,
} from "antd";
import { React, useEffect, useState } from "react";
import ButtonComp from "../../ButtonComp/ButtonComp";
import CustomTable from "../../Table/CustomTable";
import BasicFormItem from "../../BasicFormItem/BasicFormItem";
import Loader from "../../../Components/Helpers/Loader";
import "./LineSettingsShift.css";
import { CheckCircleFilled, edit, trash, CloseCircleFilled } from "../../../Utils/imports";
import { LineSettingsShiftForm } from "../../../Utils/constants";
import { LineSettingsShiftVar } from "../../../Utils/variables";
import { useDispatch, useSelector } from "react-redux";
import { antIcon, formatCapabilities} from "../../../Helpers/helpers";
import { success,error } from "../../Helpers/notification";
import { access_capabilities } from "../../../Utils/constants";
import moment from "moment";
import { CheckCircleOutlined } from "@ant-design/icons";
import { createShift, deleteShift, editShift } from "../../../API-Interaction/apiServices/plantSettings.api";
import { getProductsList } from "../../../API-Interaction/apiServices/productionLine.api";
import SyncMachine from "../SyncMachine/SyncMachine";
import { onDowntimeValuesSubmit } from "../../../API-Interaction/apiServices/productionLine.api";
import { getFromLocalStorage, setToLocalStorage, filterByChoice, canPerformAction } from "../../../Helpers/helpers";
import roles from "../../../Helpers/roles";

import { RiFontSize } from "react-icons/ri";
const { Panel } = Collapse;
const { TextArea } = Input;
const {
    heading,
    add_shift,
    name,
    product,
    select_time,
} = LineSettingsShiftVar;
const LineSettingsShift = () => {
    const [form] = Form.useForm()
    const [selectedMachines, setState] = useState([]);

    const dispatch = useDispatch()
    const { current = null} = useSelector(state => state.plant)
    //let { plant = null, line = null, machine = null } = JSON.parse(localStorage.getItem('current'))

    
    let {plant = null, machine = null,line=null} = JSON.parse(localStorage.getItem('current'));
    let shiftSettings  = machine?.shifts || line?.shifts || []
    // let products = [current?.shift.product.name]
    const { pageLoaders, componentLoaders } = useSelector(state => state.utils.loaders)

    // let { shiftSettings = null } = useSelector(state => state?.plant?.current?.plant)
    const [shiftModal, setShiftModal] = useState(false);
    const [doWhat, setDoWhat] = useState('create');
    const [switches] = useState({ status: false, medium: false });
    const { products } = useSelector(state => state.productionLine)
    const [mode, setMode] = useState('add')
    const [currentRow, setCurrent] = useState({})
    const handleChange = (...params) => {
        let [two] = params
        console.log(`${two}`);
    };

    useEffect(() => {
        current?.line && getProductsList(dispatch,current)
    }, [current])
    const timeStringToFloat = (time) => {
        var hoursMinutes = time.split(/[.:]/);
        var hours = parseInt(hoursMinutes[0], 10);
        var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
        return hours + minutes / 60;
      }
      function changeProducts(line, values, selectedProduct, obj, shifts, log, currentShift, changeMode, machine, plantId, isCurrent=null) {
        let data = {}
        const {plant} = current;
        let productionLine = {...line}
        let xyz = {}
        if (machine) {
            for(let x = 0;x<(productionLine.machines).length;x++){
                if(productionLine.machines[x].machineName == machine.machineName)
                {
                    (shifts).forEach(ele => {
                        let found= false;
                        (productionLine.machines[x].shifts).forEach(element => {
                        if(ele.range==element.range)
                        found = true;
                    });
                    if(!found)
                    {
                        values = ele;
                    }
                });
                productionLine.machines[x]['shifts'] = shifts;
                //(productionLine.machines[x].shifts).push(values);
                }
            }
            
          data = {
            'updatedAt':new Date(),
            '_id':productionLine._id,
            'machines': productionLine.machines,
            'plantId':plant._id
          }
        }
        else {
          data = {
            shifts,
            'updatedAt':new Date(),
            '_id':productionLine._id,
            'plantId':plant._id
          }
        }
        /*
        if (isCurrent)
        {
          let productLog = {
            lineId: productionLine.id,
            plantId,
            machine: machine && machine.machineName,
            time: new Date(),
            detailsAfter: {
              ...values,
              range: `${values.from}-${values.to}`,
              product: selectedProduct,
            },
            detailsBefore: obj
          };
          dispatch({
            type: 'productLog/create',
            payload: {
              params: {
                productionLineId: productionLine.id,
              },
              data: productLog,
            },
          });
        }
        */
        onDowntimeValuesSubmit(dispatch, data)
    /*    dispatch({
          type: 'productionLine/update',
          payload: {
            id: productionLine.id,
            data,
            log
          },
        });*/
        // send email
       /* emailOnLineSettingsChange({
          productionLine,
          currentShift,
          type: 'shift-settings-change',
          machine: machine ? machine.machineName : null,
        });
        changeMode('list');
        */
      }
      const convertTimeString = ({ string, day }) => {
        const split = string.split(':');
      
        if (split.length < 2) {
          console.log('Incorrect time format', string);
          return;
        }
      
        return moment(day)
          .startOf('day')
          .add(split[0], 'hours')
          .add(split[1], 'minutes')
          .toDate();
      };
    const currentShift = function(shifts) {
        const timeNow = moment(new Date())
          .toDate();
        return shifts.reduce((result, shift) => {
          let fromTime = convertTimeString({ string: shift.from, day: timeNow });
          let toTime = convertTimeString({ string: shift.to, day: timeNow });
      
          // if ending time is of after midnight
          if (moment(toTime).isBefore(fromTime)) {
            // if current time is after midght
            if (moment(fromTime).isAfter(moment(timeNow))) {
              fromTime = moment(fromTime)
                .subtract(1, 'day')
                .toDate();
            } else {
              toTime = moment(toTime)
                .add(1, 'day')
                .toDate();
            }
          }
      
          if (moment(fromTime).isBefore(timeNow) && moment(toTime).isAfter(timeNow)) {
            result = {
              fromTime,
              toTime,
              ...shift,
            };
          }
          return result;
        }, false);
      };
    const onFinish = async (values) => {
        let { plant = null, line = null, machine = null } = JSON.parse(localStorage.getItem('current'))
        let shifts = []
        //console.log(typeof values.product);
        if(typeof values.product == 'object' && typeof values.product != 'string')
        values.product = values.product[0]
        //return;
        if (machine)
            shifts = machine.shifts ? [...machine.shifts]:[]
        else 
            shifts = line.shifts ? [...line.shifts] : [];
        
        let shiftExists = false
        let shiftBreakdown = [ {'from':timeStringToFloat(values.from) , 'to': timeStringToFloat(values.to)}]
        if (timeStringToFloat(values.to) <  timeStringToFloat(values.from))
        {
            shiftBreakdown = [
            {'from':timeStringToFloat(values.from) , 'to': timeStringToFloat('23:59')},
            {'from':timeStringToFloat('00:00') , 'to': timeStringToFloat(values.to)}
            ]
        }
        for (let breakdown of shiftBreakdown)
        {
            for (let shift of shifts) {
            let tempBreakdowns = [ {'from':timeStringToFloat(shift.from) , 'to': timeStringToFloat(shift.to)}]
            if (timeStringToFloat(shift.to) <  timeStringToFloat(shift.from))
            {
                tempBreakdowns = [
                {'from':timeStringToFloat(shift.from) , 'to': timeStringToFloat('23:59')},
                {'from':timeStringToFloat('00:00') , 'to': timeStringToFloat(shift.to)}
                ]
            }
            for (let tempBreakdown of tempBreakdowns)
            {
                if ((breakdown.from < tempBreakdown.to) && (tempBreakdown.from < breakdown.to)) 
                {
                if ( currentRow && currentRow.name == shift.name)
                    continue
                    
                /*this.props.form.setFields({
                    from: {
                    value: values.from,
                    errors: [new Error('Range overlaps with existing shift!')],
                    },
                    to: {
                    value: values.to,
                    errors: [new Error('Range overlaps with existing shift!')],
                    },
                });*/
                shiftExists = true
                break
                }
            }
            if (shiftExists)
            break
            }
            if (shiftExists)
            break
        }
        if (shiftExists)
           {
            error("Shift Overlapping, Please change times")
            setDoWhat('create')
            setShiftModal(false)
             return
            }


            let selectedProduct = products.filter(product => product._id === values.product);
            if (selectedProduct.length < 1) {
                error("Selected Product Not Found")
                setDoWhat('create')
                setShiftModal(false)
            return;
            }

            let user = await getFromLocalStorage('user')
            let data = filterByChoice(current?.plant?.accessControl, 'email', user?.username)
            let currentUser = data.length ? data : roles['superAdmin']

            selectedProduct = selectedProduct[0];
            selectedProduct = {
            id: selectedProduct._id,
            name: selectedProduct.productName,
            lineSpeed: selectedProduct.lineSpeed,
            primary: selectedProduct.primary,
            secondary: selectedProduct.secondary
            };
            if(line.isRazorLine)
            selectedProduct.Weight = selectedProduct.Weight? selectedProduct.Weight : null;
            let log = {
            lineId: line.id,
            lineName: line.lineName,
            hallName: line.hallName,
            shiftName: '',
            userId: currentUser.id?currentUser.id:'1323',
            email: currentUser.email,
            time: new Date(),
            plantName: plant.plantName,
            plantId: plant.id,
            action: 'Shift Added',
            detailsAfter:{
                ...values,
                range: `${values.from}-${values.to}`,
                product: selectedProduct,
            },
            }
            
            if (doWhat === 'create') {
            shifts.push({
                ...values,
                weeklySchedule: {'Monday':false, 'Tuesday':false, 'Wednesday' :false, 'Thursday': false,'Friday':false,'Saturday':false,'Sunday':false},
                range: `${values.from}-${values.to}`,
                product: selectedProduct,
            });
            changeProducts(line, values, selectedProduct, null, shifts, log, currentRow,doWhat, machine, plant.id)
            } else if (currentRow) {
            if (!currentRow.product.secondary)
            {
                let productBefore = products.find(product => product._id === currentRow.product.id);
                productBefore = {
                id: productBefore.id,
                name: productBefore.productName,
                lineSpeed: productBefore.lineSpeed,
                primary: productBefore.primary,
                secondary: productBefore.secondary
                }
                if(line.isRazorLine)
                productBefore.Weight = productBefore.Weight? productBefore.Weight : null;
                currentRow.product = productBefore
            }
            const { createdAt, id, weeklySchedule,  ...obj } = currentRow
            log.detailsBefore = obj
            log.action = 'Shift Updated'
            shifts = shifts.reduce((accumulator, shift) => {
                if (currentRow.range === shift.range) {
                return accumulator.concat({
                    ...values,
                    range: `${values.from}-${values.to}`,
                    product: selectedProduct,
                });
                }

                return accumulator.concat(shift);
            }, []);
            let currShift = currentShift(shifts)
            changeProducts(line, values, selectedProduct, null, shifts, log, currentRow,doWhat, machine, plant.id)

            //add Changeover to productlogs if present
            //if (current.product.id != selectedProduct.id && currShift && currShift.range === `${values.from}-${values.to}`)
           // {
           // this.setState({changeModal:true, changeParams: {
           //     productionLine, values, selectedProduct, obj, dispatch, shifts, log, currentShift, changeMode, machine
           // }})
           // }
           // else {
           // changeProducts(productionLine, values, selectedProduct, obj, dispatch, shifts, log, currentShift, changeMode, machine, plant.id)
           // }
            }
        
        

       // if (doWhat === 'edit'){
       //     await editShift(dispatch, { values}, current)
      //  }
      //  if (doWhat !== 'edit')
      //      await createShift(dispatch, { ...values, products }, current)
        setDoWhat('create')
        setShiftModal(false)
    };

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    const handleEdit = (record) => {
        //console.log({ record, lines: record?.lines?.map((line) => ({ label: line.lineName, value: line?.id })) })
        setDoWhat('edit')
        setMode('edit');
        setCurrent(record);
        form.setFieldsValue({
            name: record?.name,
            to: record?.to,
            from: record?.from,
            productName: record?.product.name,
            product:record?.product._id||record?.product.id,
            fromTime: record?.fromTime,
            toTime: record?.toTime,
            time: moment(record?.time)
        })
        setShiftModal(true)
    }

    const handleDelete = async (record) => {
        //console.log(record)
        let { plant = null, line = null, machine = null } = JSON.parse(localStorage.getItem('current'))
        let shifts = []
        let data = {}
        //values.product = values.product[0]
        if (machine)
            shifts = machine.shifts ? [...machine.shifts]:[]
        else 
            shifts = line.shifts ? [...line.shifts] : [];
            shifts = shifts.filter(item => item.range !== record.range);
            if (machine) {
                for(let x = 0;x<(line.machines).length;x++){
                    if(line.machines[x].machineName == machine.machineName)
                    {
                    line.machines[x]['shifts'] = shifts;
                    //(productionLine.machines[x].shifts).push(values);
                    }
                }
                
              data = {
                'updatedAt':new Date(),
                '_id':line._id,
                'machines': line.machines,
                'plantId':plant._id
              }
            }
            else {
              data = {
                shifts,
                'updatedAt':new Date(),
                '_id':line._id,
                'plantId':plant._id
              }
            }
            onDowntimeValuesSubmit(dispatch, data)
        //await deleteShift(dispatch, { products, rec: record }, current)
    }
    const sync = async() => {
        // if((admin('shift-access')))
        // {
        //   notification.error({
        //     message: 'Not have access to sync. ',
        //   });
        //   //this.handleCancel();
        //   return;
        // }
        //   try {
        //     await syncMachineShifts({plantId: current?.plant?._id, lineId: current?.line?.id, machines: selectedMachines, productionLine:{
        //       shifts:current?.shift?.name, 
        //       machines:current?.machine?.machines
        //     },machine})
        //     notification.success({
        //       message: 'Sync Successful',
        //     });
    
        //   }
        // catch(err) {
        //   console.log(err)
        //   notification.error({
        //     message: 'Sync Failed',
        //   });
        // }
    }
    const ShiftModal = () => {

        return (
            <Modal
                title={<h2>{mode=='add'?'Add Shift':'Edit Shift'}</h2>}
                centered
                open={shiftModal}
                maskClosable={false}
                onCancel={() => setShiftModal(false)}
                footer={null}
                className="ShiftModal"
            >
                <Spin indicator={antIcon} spinning={componentLoaders?.shiftModal || false} >
                <div>
                <Form
                        form={form}
                        name="lineShiftForm"
                        className="lineShiftForm"
                        labelCol={{
                            span: 8,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        initialValues={{
                            remember: false,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <h4>{name}</h4>
                        <Form.Item
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: "Enter Name",
                                },
                            ]}
                        >
                            <Input className="boxBorderRad width100P" placeholder={"Add Name"} />
                        </Form.Item>
                        <Row gutter={6}>
                            <Col span={12}>
                                <label style={{fontSize: '14px', fontWeight: 'bold', textTransform: 'uppercase'}}>{select_time}</label>
                                <h5>From <span>{'(Format hh:mm)'}</span></h5>
                                <Form.Item
                                    name="from"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select time!",
                                        },
                                    ]}
                                >
                            <Input className="boxBorderRad width100P" placeholder={"From Time"} />
                                </Form.Item>
                            </Col>
                            <Col span={12} className="col2">
                                <h3> </h3>
                            <h5>To <span>{'(Format hh:mm)'}</span></h5>
                                <Form.Item
                                    name="to"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select time!",
                                        },
                                    ]}
                                >
                            <Input className="boxBorderRad width100P" placeholder={"To Time"} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <h4>{product}</h4>
                        <Form.Item
                            name="product"
                            rules={[
                                {
                                    required: true,
                                    message: "Please select product!",
                                },
                            ]}
                        >
                            <Select
                                style={{ width: '100%' }}
                                tokenSeparators={[',']}>
                                    {products.map(machine => (
                                        <Select.Option key={machine.productName} value={machine._id}>
                                            {machine.productName}
                                        </Select.Option>
                                    ))}
                            </Select>
                        </Form.Item>
                        <Row className="dflex alignCenter justifyCenter gap10" >
                    <Form.Item>
                        <ButtonComp
                            style={{ width: "180px" }}
                            theme={"blue"}
                            htmlType="submit"
                            text="Apply"
                            icon={<CheckCircleFilled />}
                        />
                    </Form.Item>
                    <Form.Item>
                        <ButtonComp
                            style={{ width: "180px" }}
                            theme={"red"}
                            text={"Cancel"}
                            icon={<CloseCircleFilled />}
                            onClick={() => setShiftModal(false)}
                        />
                    </Form.Item>
                </Row>
                    </Form>
        </div>
                </Spin>
            </Modal >
        );
    };

    const LineSettingsShiftTableColumns = [
        {
          title: "Name",
          dataIndex: "name",
          render: (text, record) => (
            <>
              {<div>{record?.name}</div>}
            </>
          )
        },
        {
          title: "From",
          dataIndex: "from",
          render: (text, record) => (
            <>
              {<div>{record?.from}</div>}
            </>
          )
        },
        {
          title: 'To',
          dataIndex: 'to',
          render: (text, record) => (
            <>
              {<div>{record?.to}</div>}
            </>
          )
        },
        {
          title: 'Product',
          dataIndex: 'product',
          render: (text, record) => (
            <>
              {<div>{record?.product.name}</div>}
            </>
          )
        },
      ];
      
      // if (canPerformAction(current, access_capabilities.canEditLineSettings)) {
        LineSettingsShiftTableColumns.push({
          title: 'Actions',
          dataIndex: 'actions',
          render: (key, rec) => (
            <div className='dflex alignCenter justifyCenter gap10'>
              <img onClick={() => handleEdit(rec)} src={edit} className="cursorPointer" /> 
              <Popconfirm
                placement="topRight"
                okText="Delete"
                cancelText="Cancel"
                okButtonProps={{ className: "popRed" }}
                cancelButtonProps={{ className: "popBlue" }}
                title="Confirm delete ?"
                onConfirm={() => { handleDelete(rec) }}
              >
                <img src={trash} className="cursorPointer" />
              </Popconfirm>
            </div>
          ),
          align: "center"
        });
      // }
      
    return (
        <>
        <Row className="pt1">
            <Row className="width100P">
                <Col span={12}>
                    <h1 className="pageHead">{heading}</h1>
                </Col>
                {/* {canPerformAction(current, access_capabilities.canEditLineSettings) && ( */}
                <Col span={12} className="dflex justifyFE">
                    <ButtonComp
                        onClick={() => { form.resetFields(); setShiftModal(true); }}
                        theme="blue"
                        text="Add Shift"
                        img="notification-bing"
                    />
                    <ShiftModal />
                </Col>
                {/* )} */}
            </Row>
            <Row className="width100P pt10 ">
                <Col span={24}>
                    <CustomTable
                        columns={LineSettingsShiftTableColumns}
                        dataSource={shiftSettings}
                    />
                </Col>
            </Row>
            </Row>
        {/* {(current?.line?.machines) &&      */}
        <Form>
            <SyncMachine
             machine={machine}
            //  canSync={(x) => canSync(x)}
             selectedMachines={selectedMachines}
             sync={sync}
             productionLine={current?.line?.productionLine}
             changeMachines = {(machines) => {setState(machines)}} />
        </Form>
{/* } */}
    </>
    );
};

export default LineSettingsShift;
